import { gql } from "@apollo/client";
import OrganizationDetailsFragment from "../../../fragments/CompanyAdminContext/OrganizationDetails";

const UPDATE_ORGANIZATION_DETAILS = gql`
  mutation updateOrganizationDetails(
    $companyId: Int!
    $details: OrganizationDetailsInput!
  ) {
    companyAdminContext {
      organizationDetails {
        updateOrganizationDetails(
          companyId: $companyId
          details: $details
        ) {
          ...OrganizationDetails
        }
      }
    }
  }
  ${OrganizationDetailsFragment}
`;

export default UPDATE_ORGANIZATION_DETAILS;
